(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["refonte-finition-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalize = (value) => (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
    const setup = (guide) => {
      if (guide.dataset.ready === 'true') return;
      const picker = guide.closest('.main-product-variant-picker');
      const variantInput = picker?.querySelector('variant-input.product-variants-js');
      if (!variantInput) return;
      const fieldsets = [...variantInput.querySelectorAll('fieldset')];
      const finishFieldset = fieldsets.find((fieldset) => {
        const legend = normalize(fieldset.querySelector('legend')?.textContent);
        return legend.includes('finition') || legend.includes('finish') || legend.includes('acabado');
      });
      const sizeFieldset = fieldsets.find((fieldset) => {
        const legend = normalize(fieldset.querySelector('legend')?.textContent);
        return legend.includes('taille') || legend.includes('size') || legend.includes('tamano');
      });
      if (!finishFieldset) return;
      finishFieldset.classList.add('rf-finish-fieldset');
      if (sizeFieldset) sizeFieldset.classList.add('rf-size-fieldset');
      finishFieldset.after(guide);
      finishFieldset.querySelectorAll('input').forEach((input) => {
        const label = input.id ? finishFieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
        if (label) label.classList.add('rf-finish-card');
      });
      if (sizeFieldset) {
        sizeFieldset.querySelectorAll('input').forEach((input) => {
          const label = input.id ? sizeFieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
          if (label) label.classList.add('rf-size-card');
        });
      }
      let startY = window.scrollY;
      let lastY = window.scrollY;
      window.addEventListener('scroll', () => {
        if (window.innerWidth > 749) return;
        const currentY = window.scrollY;
        if (currentY > lastY && currentY - startY > 80) guide.classList.add('is-collapsed');
        lastY = currentY;
      }, { passive: true });
      finishFieldset.addEventListener('change', () => guide.classList.remove('is-collapsed'));
      const lightbox = guide.querySelector('[data-rf-finish-lightbox]');
      const lightboxImage = lightbox?.querySelector('.rf-finish-lightbox__image');
      const closeLightbox = () => {
        if (!lightbox) return;
        lightbox.removeAttribute('open');
        document.documentElement.style.overflow = '';
      };
      const openLightbox = (media) => {
        const image = media.querySelector('.rf-finish__image');
        if (!lightbox || !lightboxImage || !image) return;
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt;
        lightbox.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        lightbox.querySelector('.rf-finish-lightbox__close')?.focus();
      };
      guide.querySelectorAll('.rf-finish__media').forEach((media) => {
        media.setAttribute('role', 'button');
        media.setAttribute('tabindex', '0');
        media.setAttribute('aria-label', media.getAttribute('aria-label') || 'Finish preview');
        media.addEventListener('click', () => openLightbox(media));
        media.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openLightbox(media);
          }
        });
      });
      lightbox?.querySelector('.rf-finish-lightbox__close')?.addEventListener('click', closeLightbox);
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && lightbox && lightbox.hasAttribute('open')) closeLightbox();
      });
      guide.dataset.ready = 'true';
    };
    const init = (root = document) => root.querySelectorAll('[data-rf-finish-guide]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    new MutationObserver(() => init()).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
